import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

/**
 * Create a landing page card component with icon (optional), title and content.
 * 
 * @param {Object} param - The component props: icon (optional), title, content
 * @returns JSX.Element
 */
const LandingCard = ({ icon, title, content }) => {
    return (
        <div className='col-lg col-md-4'>
            <div className="card landing">
                {icon && <FontAwesomeIcon icon={icon} className="icon" />}
                <p className="fw-bold mb-1">{title}</p>
                <p className="mb-0 text-break">{content}</p>
            </div>
        </div>
    );
}

LandingCard.propTypes = {
    icon: PropTypes.object,
    title: PropTypes.string.isRequired,
    content: PropTypes.string.isRequired
};

export default LandingCard;